import React from 'react';
import { Box, Typography, Alert, CircularProgress } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { ConfirmDialog } from '../../ui';

// "Save Growth as version 8?" — the server-computed diff and who it hits.
const PlanReviewDialog = ({ open, onClose, onConfirm, loading, impact, impactLoading, planName, nextVersion, t }) => (
  <ConfirmDialog
    open={open}
    onClose={onClose}
    tone="primary"
    icon={SaveOutlinedIcon}
    title={t('Save {{name}} as version {{version}}?', { name: planName, version: nextVersion, defaultValue: `Save ${planName} as version ${nextVersion}?` })}
    cancelLabel={t('ga.common.cancel')}
    confirmLabel={t('Save version {{version}}', { version: nextVersion, defaultValue: `Save version ${nextVersion}` })}
    onConfirm={onConfirm}
    loading={loading}
    confirmDisabled={impactLoading || !impact}
  >
    {impactLoading && <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={22} /></Box>}
    {impact && (
      <Box sx={{ mt: 1.5 }} data-testid="plan-impact">
        <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'background.default', border: '1px solid', borderColor: 'divider', fontFamily: 'monospace', fontSize: 13 }}>
          {impact.changeSummary.length === 0
            ? <Typography variant="body2" color="text.secondary">{t('No changes', { defaultValue: 'No changes' })}</Typography>
            : impact.changeSummary.map((line) => <Typography key={line} variant="body2" component="div">{line}</Typography>)}
        </Box>
        <Alert severity={impact.overLimit.length > 0 || impact.removedFeatures.length > 0 ? 'warning' : 'info'} sx={{ mt: 1.5 }}>
          {t('{{count}} companies are on this plan and get these changes immediately.', { count: impact.affectedCompanies, defaultValue: `${impact.affectedCompanies} companies are on this plan and get these changes immediately.` })}
          {impact.removedFeatures.length > 0 && (
            <Box component="span" sx={{ display: 'block', mt: 0.5 }}>
              {t('They lose access to: {{features}}. Their data is kept.', { features: impact.removedFeatures.join(', '), defaultValue: `They lose access to: ${impact.removedFeatures.join(', ')}. Their data is kept.` })}
            </Box>
          )}
          {impact.overLimit.map((row) => (
            <Box component="span" key={row.featureKey} sx={{ display: 'block', mt: 0.5 }}>
              {t('{{count}} already exceed the new {{feature}} limit of {{limit}} — they keep their data but cannot add more.', {
                count: row.companies.length, feature: row.featureKey, limit: row.limit,
                defaultValue: `${row.companies.length} already exceed the new ${row.featureKey} limit of ${row.limit} — they keep their data but cannot add more.`,
              })}
              {' '}{row.companies.slice(0, 5).map((c) => c.companyName || c.companyId).join(', ')}
            </Box>
          ))}
        </Alert>
      </Box>
    )}
  </ConfirmDialog>
);

export default PlanReviewDialog;
